module.exports = __webpack_public_path__ + "img/logo_platinriver.9ba3d24.svg";